import styled from 'styled-components';
import {Typography} from "@mui/material";

export const StyledDigitizationEditionPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

interface MainContainerProps {
    $row?: boolean;
}

export const StyledDigitizationCard = styled.div<MainContainerProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({$row}) => $row ? 'row' : 'column'};
    min-height: 0;
    overflow: auto;
    
    border-radius: 32px;
    border: 1px solid #E2E8F0;
    background: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
`;

export const StyledDigitizationContent = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: auto;
`;

export const DigitizationContentLeftPanel = styled.div`
    display: flex;
    flex: 0 0 50%;
    min-width: 0;
    flex-direction: column;
    border-right: 1px solid #E2E8F0;
    overflow: hidden;
`;

export const DigitizationContentRightPanel = styled.div`
    display: flex;
    flex: 0 0 50%;
    min-width: 0;
    flex-direction: column;
    background: #ffffff;
`;

export const DigitizationContentSubtitle = styled(Typography)`
    && {
        color: #69758B;
        background: #FAFAFA;
        font-size: 12px;
        font-weight: 500;
        padding: 8px 16px;
        letter-spacing: 0.8px;
        border-top: solid 0.8px #E2E8F0;
        border-bottom: solid 0.8px #E2E8F0;
        text-transform: uppercase;
    }
`;